import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { shimmerPlaceholderConfig } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import { headerLoadingConfig, settingsCardLoadingConfig } from './SettingsLoading.Config';
import styles from './SettingsLoading.Styles';

function SettingsLoading({ theme }) {
  const renderCard = key => (
    <>
      <View style={styles.headerContainer}>
        <Shimmer config={headerLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
      </View>
      <View style={styles.cardContainerStyle(theme)} key={key}>
        <Shimmer
          config={settingsCardLoadingConfig}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      </View>
    </>
  );

  return <View style={styles.containerStyle}>{_map(Array(2), (_, key) => renderCard(key))}</View>;
}

SettingsLoading.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default SettingsLoading;
